import { render, staticRenderFns } from "./QuestionarioClinicaEspecialidade.vue?vue&type=template&id=6c13be80&scoped=true"
import script from "./QuestionarioClinicaEspecialidade.vue?vue&type=script&lang=js"
export * from "./QuestionarioClinicaEspecialidade.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioClinicaEspecialidade.vue?vue&type=style&index=0&id=6c13be80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13be80",
  null
  
)

export default component.exports